import API from '../Common/axios';
import {
  RegisterRequestEmailInterface,
  RegisterRequestInterface,
  RegisterRequestMinimalInterface,
} from '../RegisterUpload/types';

type FindRegisterRequestsParams = {
  query?: string;
  filter_operational_managers?: (string | undefined)[];
  filter_residence_groups?: (number | undefined)[];
  filter_to_date?: string;
  show_not_handled?: boolean;
  show_requires_completion?: boolean;
  show_under_investigation?: boolean;
  show_approved?: boolean;
  show_exception_valid_previous?: boolean;
  show_exception_under_fourteen?: boolean;
  show_exception_not_required?: boolean;
  show_exception_migration?: boolean;
  show_complete?: boolean;
  sort_by?: string;
  sort_order?: 'asc' | 'desc';
  page?: number;
};

type CreateRegisterRequestParams = {
  user_id: number | string;
  force_create: boolean;
};

type UpdateRegisterRequestParams = {
  complete: boolean;
  register_type: string;
};

type ApproveRegisterRequestParams = {
  valid_from: string;
};

type RequestCompletionRegisterRequestParams = {
  text: string;
};

export type RegisterRequestFileInterface = {
  id: number;
  filename: string;
  size: number;
  mime_type: string;
};

export type RegisterRequestHistoryInterface = {
  id: number;
  event_type: string;
  // retention_days: after how many days the retention job deleted the file (file_deleted_automatically)
  metadata: { retention_days?: number };
  created_at: string;
};

export type RegisterRequestShowInterface = RegisterRequestInterface & {
  previous_id?: number | null;
  next_id?: number | null;
  operational_manager: {
    id: number;
    first_name: string;
    surname?: string;
    email: string;
  };
  register_request_uploads: RegisterRequestFileInterface[];
  histories: RegisterRequestHistoryInterface[];
  register_request_emails: RegisterRequestEmailInterface[];
  editable: boolean;
};

export async function findRegisterRequests(params: FindRegisterRequestsParams = {}) {
  return API.get<{ data: RegisterRequestInterface[]; meta: { count: number } }>('v1/register_requests', { params });
}

export async function getRegisterRequest(id: number, params: FindRegisterRequestsParams = {}) {
  return API.get<{ data: RegisterRequestShowInterface }>(`v1/register_requests/${id}`, { params });
}

export async function createRegisterRequest(params: CreateRegisterRequestParams) {
  return API.post<{ data: RegisterRequestMinimalInterface }>('v1/register_requests', {
    register_request: params,
  });
}

export async function updateRegisterRequest(id: number, register_request: UpdateRegisterRequestParams) {
  return API.patch<{ data: RegisterRequestMinimalInterface }>(`v1/register_requests/${id}`, { register_request });
}

export async function deleteRegisterRequest(id: number) {
  return API.delete(`v1/register_requests/${id}`);
}

export async function approveRegisterRequest(id: number, register_request: ApproveRegisterRequestParams) {
  return API.patch<{ data: RegisterRequestMinimalInterface }>(`v1/register_requests/${id}/approve`, {
    register_request,
  });
}

export async function requestCompletionRegisterRequest(
  id: number,
  register_request: RequestCompletionRegisterRequestParams
) {
  return API.patch<{ data: RegisterRequestMinimalInterface }>(`v1/register_requests/${id}/request_completion`, {
    register_request,
  });
}

export async function investigateRegisterRequest(id: number) {
  return API.patch<{ data: RegisterRequestMinimalInterface }>(`v1/register_requests/${id}/investigate`);
}

export async function resetRegisterRequest(id: number) {
  return API.patch<{ data: RegisterRequestMinimalInterface }>(`v1/register_requests/${id}/reset`);
}

export async function getOngoingRegisterRequest() {
  return await API.get<{ data: RegisterRequestMinimalInterface }>('v1/register_requests/ongoing');
}
